import { type AxiosInstance } from "axios";

/**
 * お問い合わせカテゴリの型
 */
export interface ContactCategory {
  pk: number;
  name: string;
}

/**
 * お問い合わせAPIのリクエスト型
 */
export interface ContactPayload {
  categoryId: number;
  content: string;
}

/**
 * お問い合わせカテゴリ一覧を取得する
 */
export const getContactCategories = async (
  apiClient: AxiosInstance
): Promise<ContactCategory[]> => {
  const { data } = await apiClient.get<ContactCategory[]>(
    "/contact/categories/"
  );
  return data;
};

/**
 * お問い合わせを送信する
 */
export const submitContact = async (
  apiClient: AxiosInstance,
  payload: ContactPayload
): Promise<void> => {
  await apiClient.post("contact/", payload);
};
